import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

export default function (_ref) {
  var open = _ref.open;

  /**
   * 弹出 Message 的静态方法的参数
   * @typedef Options
   * @property {any} title
   * @property {any} [content]
   * @property {Function} [onOk]
   * @property {Function} [onCancel]
   */

  /**
   * 弹出帮助窗口
   * @param {Options} options
   * @returns {number} id
   */
  function help(options) {
    open(_objectSpread({
      type: 'help',
      okText: '确定'
    }, options));
  }
  /**
   * 弹出警告窗口
   * @param {Options} options
   * @returns {number} id
   */


  function warning(options) {
    open(_objectSpread({
      type: 'warning',
      okText: '确定'
    }, options));
  }
  /**
   * 弹出错误窗口
   * @param {Options} options
   * @returns {number} id
   */


  function danger(options) {
    open(_objectSpread({
      type: 'delete',
      okText: '确定'
    }, options));
  }
  /**
   * 弹出成功窗口
   * @param {Options} options
   * @returns {number} id
   */


  function success(options) {
    open(_objectSpread({
      type: 'success',
      okText: '确定'
    }, options));
  }
  /**
   * 弹出确认窗口
   * @param {Options} options
   * @returns {number} id
   */


  function confirm(options) {
    return open(_objectSpread({
      type: 'question',
      okText: '确定',
      cancelText: '取消'
    }, options));
  }

  return {
    help: help,
    warning: warning,
    danger: danger,
    success: success,
    confirm: confirm
  };
}